<template>
    <v-card elevation="0">
        <v-card-title class="pa-3">
            <span>OAuth Clients</span>
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-dialog
                        v-model="showCreateClientForm"
                        max-width="870px"
                        persistent
                        scrollable
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                v-on="{ ...tooltip }"
                                @click="showCreateClientForm = true"
                                icon>
                                <v-icon>add</v-icon>
                            </v-btn>  
                        </template>
                        <v-card class="background-2 round-card">
                            <v-card-title primary-title class="subtitle-1 background-2">
                            Nuovo Client
                            </v-card-title>

                            <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                                <v-form ref="form">
                                    <v-container>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                md="6"
                                            >
                                                <v-text-field
                                                    @keyup.enter="store"
                                                    v-model="createForm.name"
                                                    label="Nome*"
                                                    required
                                                    hint="Qualcosa che i tuoi utenti riconosceranno e di cui si fideranno."
                                                ></v-text-field>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                md="6"
                                            >
                                                <v-text-field
                                                    @keyup.enter="store"
                                                    v-model="createForm.redirect"
                                                    label="Redirect URL*"
                                                    data-vv-name="Redirect URL"
                                                    v-validate="{required: true, url: {require_protocol: true }}"
                                                    required
                                                    hint="L'URL di richiamata dell'autorizzazione dell'applicazione."
                                                ></v-text-field>
                                            </v-col>

                                        </v-row>
                                    </v-container>
                                </v-form>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                text
                                @click="showCreateClientForm = false"
                            >
                                Chiudi
                            </v-btn>
                            <v-btn
                                color="info"
                                text
                                @click="store"
                                :loading="loading"
                            >
                                Salva
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>                  
                </template>
                <span>Nuovo Client</span>
            </v-tooltip>
        </v-card-title>

        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="clients"
                :items-per-page="5"
                class="elevation-1"
            >
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                                icon
                                small
                                class="mx-0"
                                @click.stop="edit(item)"
                            >
                                <v-icon color="info">edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Modifica</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                                icon
                                small
                                class="mx-0"
                                @click.stop="destroy(item)"
                            >
                                <v-icon color="red">delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
	import Vue from 'vue'

    export default {
        name: 'passport-clients',
        /*
         * The component's data.
         */
        data() {
            return {
                clients: [],
                headers: [
                    { text: 'Azioni', value: 'actions', sortable: false },
                    { text: 'Client ID', value: 'id' },
                    { text: 'Nome', value: 'name' },
                    { text: 'Secret', value: 'secret' },
                ],

                createForm: {
                    errors: [],
                    name: '',
                    redirect: ''
                },

                showCreateClientForm: false,
                loading: false,
                editId: null
            };
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component.
             */
            prepareComponent() {
                this.getClients();
            },

            /**
             * Get all of the OAuth clients for the user.
             */
            getClients() {
                Vue.axios.get('/oauth/clients')
                    .then(response => {
                        this.clients = response.data;
                    });
            },

            /**
             * Create a new OAuth client for the user.
             */
            store() {
                this.$refs.form.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    if(this.editId) {
                        this.persistClient(
                            'put', '/oauth/clients/' + this.editId,
                            this.createForm
                        );
                    } else {
                        this.persistClient(
                            'post', '/oauth/clients',
                            this.createForm
                        );
                    }

                    this.editId = null
                })
            },

            /**
             * Edit the given client.
             */
            edit(client) {
                this.editId = client.id;
                // this.createForm.id = client.id;
                this.createForm.name = client.name;
                this.createForm.redirect = client.redirect;

                this.showCreateClientForm = true
            },

            /**
             * Persist the client to storage using the given form.
             */
            persistClient(method, uri, form) {
                form.errors = [];

                Vue.axios[method](uri, form)
                    .then(response => {
                        this.getClients();

                        form.name = '';
                        form.redirect = '';
                        form.errors = [];

                        this.showCreateClientForm = false
                    })
                    .catch(error => {
                        if (typeof error.response.data === 'object') {
                            form.errors = _.flatten(_.toArray(error.response.data.errors));
                        } else {
                            form.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },

            /**
             * Destroy the given client.
             */
            destroy(client) {
                Vue.axios.delete('/oauth/clients/' + client.id)
                    .then(response => {
                        this.getClients();
                    });
            }
        }
    }
</script>
